
import {firstStep, secondStep, thirdStep} from "../../../../../../utils/const/createEnvConsts";
import ThirdStep from "./thirdStep/ThirdStep";
import SecondStep from "./secondStep/SecondStep";
import FirstStep from "./firstStep/FirstStep";
import {useState} from "react";


const DynamicStepContent = (props) => {

    const {index} = props;
    const [scenarioRadioButton, setScenarioRadioButton] = useState("");

    if (index === firstStep) {

        return <FirstStep scenario={scenarioRadioButton} setScenario={setScenarioRadioButton} handleBack={()=>{}}/>

    } else if (index === secondStep) {

        return <SecondStep scenario={scenarioRadioButton}/>

    } else if (index === thirdStep) {

        return <ThirdStep/>

    }
}

export default DynamicStepContent;
